import { LEAD_TABLE_SORTING_ORDER } from "../../Actions/ActionConstants";

const LeadTableSortingReducer = (state = null, action) => {
    switch (action.type) {
        case LEAD_TABLE_SORTING_ORDER:
            return action.data
        default:
            return state;
    }
}

export default LeadTableSortingReducer;